import { FunctionComponent, useEffect } from "react";
import { notification } from "antd";
import { useAppDispatch, useAppSelector } from "@store/store";
import {
  removeToastAction,
  selectToasts,
  ToastType,
} from "@store/toastReducer";

import "./Toast.css";
import { WarningIcon } from "@icons/WarningIcon";
import { CheckWithCircleIcon } from "@icons/CheckWithCircleIcon";
import { InfoIcon } from "@icons/InfoIcon";
import { CloseInCircleIcon } from "@icons/CloseInCircleIcon";

const ToastMessage = ({
  message,
  type,
}: {
  message: string;
  type: ToastType;
}) => {
  return (
    <div className="toast-message-content">
      {type === "warning" && <WarningIcon size={20} />}
      {type === "success" && <CheckWithCircleIcon size={20} />}
      {type === "info" && <InfoIcon size={20} />}
      {type === "error" && <CloseInCircleIcon size={20} />}
      {message}
    </div>
  );
};

const colorMap: Record<ToastType, string> = {
  success: "#EBF7DF",
  error: "#FFF1F0",
  info: "#F5F9FF",
  warning: "#FFF7E6",
};

const borderColorMap: Record<ToastType, string> = {
  success: "#B7EB8F",
  error: "#FFA39E",
  info: "#BFE0FF",
  warning: "#FFD591",
};

const Toast: FunctionComponent = () => {
  const [messageApi, contextHolder] = notification.useNotification();
  const toasts = useAppSelector(selectToasts);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (toasts.length > 0) {
      const toast = toasts[0];
      messageApi.open({
        message: <ToastMessage message={toast.message} type={toast.type} />,
        placement: "top",
        className: "toast-message",
        duration: 2,
        closable: toast.closable,
        style: {
          padding: `8px 16px`,
          gap: 8,
          borderRadius: 8,
          backgroundColor: colorMap[toast.type],
          border: `1px solid ${borderColorMap[toast.type]}`,
          display: "flex",
          width: "max-content",
        },
      });
      dispatch(removeToastAction(toast.id));
    }
  }, [dispatch, messageApi, toasts]);

  return <>{contextHolder}</>;
};

export { Toast };
